<template>
  <div class="printing-spool">
    <div v-if="loading" class="text-center py-4">
      <CSpinner color="primary" />
      <div class="mt-2 text-muted">
        <translate translate-context="edge-prints.spool">Loading print jobs...</translate>
      </div>
    </div>

    <PrintJobList
      v-else
      :print-jobs="printJobs"
      :loading="loading"
      expandable
      @zoom="showMediaZoom"
      @toggle-select-all="handleToggleSelectAll"
    >
      <template #photos="{ job }">
        <PrintJobMediaPreview
          ref="printJobPreview"
          :print-job="job"
          @zoom="showMediaZoom"
        />
      </template>
    </PrintJobList>

    <!-- Selection Bar for reprinting -->
    <SelectionBar @open-print-summary="openReprintSummary" />

    <!-- Media Zoom Modal -->
    <MediaZoomModal ref="mediaZoomModal" />

    <!-- Reprint Summary Modal -->
    <PrintSummaryModal
      ref="printSummaryModal"
      @print-completed="handleReprintCompleted"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PrintJobList from './PrintJobList.vue'
import PrintJobMediaPreview from './PrintJobMediaPreview.vue'
import SelectionBar from './SelectionBar.vue'
import MediaZoomModal from '@/domain/edgeOrders/shared/MediaZoomModal.vue'
import PrintSummaryModal from './PrintSummaryModal.vue'

export default {
  name: 'PrintingSpool',
  components: {
    PrintJobList,
    PrintJobMediaPreview,
    SelectionBar,
    MediaZoomModal,
    PrintSummaryModal
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters('edgePrints', ['printJobs'])
  },

  mounted() {
    this.loadPrintJobs()
  },

  methods: {
    ...mapActions('edgePrints', ['fetchPrintJobs']),

    async loadPrintJobs() {
      this.loading = true
      try {
        const params = {
          page_size: 100
        }
        await this.fetchPrintJobs(params)
      } finally {
        this.loading = false
      }
    },

    handleToggleSelectAll(printJobId) {
      // Find the PrintJobMediaPreview component for this job and call its toggleSelectAll
      const previews = this.$refs.printJobPreview
      if (Array.isArray(previews)) {
        const preview = previews.find(p => p.printJob.id === printJobId)
        if (preview) {
          preview.toggleSelectAll()
        }
      } else if (previews && previews.printJob.id === printJobId) {
        previews.toggleSelectAll()
      }
    },

    openReprintSummary(groupedItems) {
      if (!groupedItems || groupedItems.length === 0) return

      // Pass the grouped items directly to the modal
      // The modal will handle both single and multiple items
      this.$refs.printSummaryModal.open(groupedItems)
    },

    handleReprintCompleted() {
      // Reload print jobs after successful reprint
      this.loadPrintJobs()
      // Note: clearAllSelections is already handled by SelectionBar after print
    },

    showMediaZoom(media) {
      this.$refs.mediaZoomModal.open(media)
    }
  }
}
</script>
